import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sub-menu h-full" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "separator w-full"
}

import { SubMenu } from '@/models/subMenu.model';
import SharedService from '@/services/SharedService';
import Menu from 'primevue/menu';


export default /*@__PURE__*/_defineComponent({
  __name: 'esSubMenu',
  props: {
    subMenuTitle: {},
    items: {},
    itemSelected: {}
  },
  setup(__props: any) {



const getIcon = (icon: string, isFillIcon: boolean, pathIcon: string) => {
  return SharedService.getIcon(icon, isFillIcon, pathIcon);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Menu), {
      model: _ctx.items,
      class: "w-full"
    }, _createSlots({
      item: _withCtx(({ item, props }) => [
        _createElementVNode("a", _mergeProps({
          class: ["flex items-center", {'font-bold-700 bg-blue-016' : _ctx.itemSelected === item.ref}]
        }, props.action), [
          (item.icon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: getIcon(item.icon, _ctx.itemSelected === item.ref, item.pathIcon),
                class: "es-tab-settings-icons"
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(item.label), 1)
        ], 16),
        (item.displaySeparator)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.subMenuTitle)
        ? {
            name: "start",
            fn: _withCtx(() => [
              _createElementVNode("h4", null, _toDisplayString(_ctx.subMenuTitle), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["model"])
  ]))
}
}

})